export default "Action not permited"